export const TransactionReportColumnsEnum = {
  REF: 'REF',
  STATUS: 'STATUS',
  DATE: 'DATE',
  TRANSACTIONREFERENCE: 'TRANSACTIONREFERENCE',
  CARD: 'CARD',
  AMOUNT: 'AMOUNT',
  FEE: 'FEE',
  TOTALSPENT: 'TOTALSPENT',
  CATEGORY: 'CATEGORY',
  AMOUNTCURRENCY: 'AMOUNTCURRENCY',
  FEECURRENCY: 'FEECURRENCY',
  TOTALSPENTCURRENCY: 'TOTALSPENTCURRENCY',
  RECEIPT: 'RECEIPT',
  NOTE: 'NOTE',
} as const;
export type TransactionReportColumnsEnum = (typeof TransactionReportColumnsEnum)[keyof typeof TransactionReportColumnsEnum];
